import { BaseService } from './base';
import { ApiRequest } from '../lib/request';
import type { ApiResponse } from '../lib/response';
import { CustomerForm } from '../models/customerForm';

export class CustomerFormService extends BaseService<CustomerForm> {
  override model = CustomerForm;

  override modelName = 'customerForm';
  override modelLabel = 'Customer Forms';

  async getDefaults({
    formId,
    customerId,
    reservationId,
    reservationCustomerId,
    prefill,
  }: {
    formId?: number;
    customerId?: number;
    reservationId?: number;
    reservationCustomerId?: number;
    prefill?: boolean;
  }): Promise<ApiResponse<CustomerForm>> {
    const request = new ApiRequest({
      method: 'POST',
      url: `${this.modelBaseUrl}/new`,
      data: {
        form: formId,
        customer: customerId,
        reservation: reservationId,
        reservationCustomer: reservationCustomerId,
        prefill,
      },
    });

    return await this.requestItem<CustomerForm>(request, CustomerForm);
  }

  async requestForm({
    formId,
    customerId,
    reservationId,
    reservationCustomerId,
    prefill,
  }: {
    formId?: number;
    customerId?: number;
    reservationId?: number;
    reservationCustomerId?: number;
    prefill?: boolean;
  }): Promise<ApiResponse<CustomerForm>> {
    const request = new ApiRequest({
      method: 'POST',
      url: `${this.modelBaseUrl}/request`,
      data: {
        form: formId,
        customer: customerId,
        reservation: reservationId,
        reservationCustomer: reservationCustomerId,
        prefill,
      },
    });

    return await this.requestItem<CustomerForm>(request, CustomerForm);
  }

  async scheduleForm({
    formId,
    customerId,
    reservationId,
    reservationCustomerId,
    prefill,
    offset = 0,
  }: {
    formId?: number;
    customerId?: number;
    reservationId?: number;
    reservationCustomerId?: number;
    prefill?: boolean;
    offset?: number;
  }): Promise<ApiResponse<CustomerForm>> {
    const request = new ApiRequest({
      method: 'POST',
      url: `${this.modelBaseUrl}/schedule`,
      data: {
        form: formId,
        customer: customerId,
        reservation: reservationId,
        reservationCustomer: reservationCustomerId,
        offset,
        prefill,
      },
    });

    return await this.requestItem<CustomerForm>(request, CustomerForm);
  }

  async reopen(customerFormId: string): Promise<ApiResponse<CustomerForm>> {
    const request = new ApiRequest({
      method: 'GET',
      url: `${this.modelBaseUrl}/${customerFormId}/reopen`,
    });

    return await this.requestItem<CustomerForm>(request, CustomerForm);
  }

  async requestUpdate(customerFormId: string): Promise<ApiResponse<CustomerForm>> {
    const request = new ApiRequest({
      method: 'GET',
      url: `${this.modelBaseUrl}/${customerFormId}/requestUpdate`,
    });

    return await this.requestItem<CustomerForm>(request, CustomerForm);
  }

  async email(customerFormId: string): Promise<ApiResponse<any>> {
    const request = new ApiRequest({
      method: 'GET',
      url: `${this.modelBaseUrl}/${customerFormId}/email`,
    });

    return await this.request(request);
  }
}
